<template>
  <v-dialog :value="dialog" max-width="860" @input="$emit('dialog', $event)">
    <v-card>
      <v-card-title class="dispatch-dialog-title">
        {{ titleText }}
        <v-spacer />
        <v-btn icon @click="$emit('dialog', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <div v-if="loading" class="text-xs-center py-5">
          <v-progress-circular indeterminate color="primary" />
          <div class="mt-3">Loading rider candidates...</div>
        </div>

        <div v-else-if="!preview">
          <div class="grey--text">No preview data</div>
        </div>

        <div v-else>
          <v-layout row wrap class="mb-3 dispatch-summary">
            <v-flex xs12 sm4>
              <div class="dispatch-summary-label">Order</div>
              <div class="dispatch-summary-value">{{ preview.orderId }}</div>
            </v-flex>
            <v-flex xs12 sm4>
              <div class="dispatch-summary-label">Online Riders</div>
              <div class="dispatch-summary-value">{{ preview.totalOnlineRiders }}</div>
            </v-flex>
            <v-flex xs12 sm4>
              <div class="dispatch-summary-label">Eligible Riders</div>
              <div class="dispatch-summary-value">{{ preview.totalEligibleRiders }}</div>
            </v-flex>
          </v-layout>

          <div
            v-for="attempt in preview.attempts || []"
            :key="attempt.attempt"
            class="dispatch-attempt-card"
          >
            <div class="dispatch-attempt-header">
              <div>
                <div class="dispatch-attempt-title">
                  Attempt {{ attempt.attempt }} • {{ attempt.radius }} km
                </div>
                <div class="dispatch-attempt-meta">
                  {{ attempt.checkedRiders }} rider(s) in queue
                </div>
              </div>
            </div>

            <div v-if="!attempt.candidates || attempt.candidates.length === 0" class="grey--text">
              No eligible riders in this radius.
            </div>

            <v-list v-else dense class="py-0">
              <v-list-tile
                v-for="(candidate, index) in attempt.candidates"
                :key="`${attempt.attempt}-${candidate.riderId}`"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    #{{ index + 1 }}
                    {{
                      candidate.riderName
                        ? `${candidate.riderName} (${candidate.riderId})`
                        : `Rider ${candidate.riderId}`
                    }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ candidate.distanceKm.toFixed(2) }} km •
                    {{ candidate.status }} •
                    updated {{ formatUpdatedAt(candidate.updatedAt) }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn flat @click="$emit('dialog', false)">Cancel</v-btn>
        <v-btn color="primary" class="black--text" :loading="confirmLoading" @click="$emit('confirm')">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "request",
    },
  },
  computed: {
    titleText() {
      return this.mode === "retry"
        ? "Retry Dispatch Candidate Queue"
        : "Dispatch Candidate Queue";
    },
    confirmText() {
      return this.mode === "retry" ? "Confirm Retry" : "Confirm Dispatch";
    },
  },
  methods: {
    formatUpdatedAt(value) {
      const timestamp = Number(value);
      if (!Number.isFinite(timestamp) || timestamp <= 0) return "-";
      return new Date(timestamp).toLocaleTimeString();
    },
  },
};
</script>

<style scoped>
.dispatch-dialog-title {
  background: linear-gradient(135deg, #fddf00, #f6c900);
  color: #1f1f1f;
  font-weight: 700;
}

.dispatch-summary {
  background: #faf7e8;
  border: 1px solid #f1e2a4;
  border-radius: 14px;
  padding: 12px 16px;
}

.dispatch-summary-label {
  color: #8b7a39;
  font-size: 12px;
  text-transform: uppercase;
}

.dispatch-summary-value {
  color: #1f1f1f;
  font-size: 20px;
  font-weight: 700;
}

.dispatch-attempt-card {
  margin-top: 14px;
  padding: 14px 16px;
  border: 1px solid #ececec;
  border-radius: 14px;
  background: #fff;
}

.dispatch-attempt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.dispatch-attempt-title {
  color: #1f1f1f;
  font-size: 16px;
  font-weight: 700;
}

.dispatch-attempt-meta {
  color: #777;
  font-size: 12px;
}
</style>
